/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".edit-comm[_ngcontent-%COMP%]{margin-right:25px}.edit-comm__button-spacing[_ngcontent-%COMP%]{margin-bottom:10px;margin-top:10px}.fieldset-container[_ngcontent-%COMP%]{margin-bottom:20px;padding-top:20px}"];
export { styles as styles };
